import { mountEnvBanner } from './env-banner';
import { createApp, getCurrentInstance } from 'vue'
import Date from './prototypes/Date'
import AsyncComputed from 'vue-async-computed'
import App from '@/App.vue'
import Sortable from 'sortablejs'
import Vue3TouchEvents from 'vue3-touch-events'

import dayjs from 'dayjs'

import router from '@/router/router'
import components from '@/components'
import store from '@/vuex'

import axiosPlugin from './plugins/axios';
import busPlugin from './plugins/bus';
import filtersPlugin from './plugins/filters';

//import './emit-patch.js';

const app = createApp(App);


app.config.globalProperties.$moment = dayjs










Array.prototype.move = function(from, to) {
	console.log(`Move from ${from} to ${to}`);

	var r = Array.from(this);
	r.splice(to, 0, r.splice(from, 1)[0]);
	return r;
};

app.use(AsyncComputed);


app.use(Vue3TouchEvents)

app.directive('sortable', {
	inserted: function (el, binding) {
		new Sortable(el, binding.value || {})
	}
});







components.forEach(c => {
    app.component(c.name, c);
});





app.config.productionTip = false;

app.use(store);
app.use(router);
app.use(axiosPlugin, { store });
app.use(busPlugin);
app.use(filtersPlugin);

app.mixin({
    methods: {
        update() {
            this.$bus.$emit('update');
        }
    }
})



// force Vue to throw instead of handling
app.callWithErrorHandling = (fn, instance, type, args) => fn(...args)


window.vue = app;

app.mount('#app');

mountEnvBanner(process.env.VUE_APP_API_BASE);
